import React from 'react'
import Banner from '../../../components/Banner'
import Navbar from '../../../components/Navbar'
import Policies from '../../../components/governance/Policies'

function PoliciesPage() {
    return (
        <div>
            <Banner />
            <Navbar />
            <Policies />
        </div>
    )
}

export default PoliciesPage